import { SPARKLINE_MARGIN } from './chart.constant';
import type { SparklinePoint } from './model/sparkline.types';

const DAY_MS = 24 * 60 * 60 * 1000;

/** YYYY-MM-DD → 일 수(UTC). 읽을 수 없으면 null */
function toDay(date: string): number | null {
  const time = Date.parse(`${date}T00:00:00Z`);
  return Number.isNaN(time) ? null : time / DAY_MS;
}

const round = (value: number) => Math.round(value * 100) / 100;

/**
 * 점 → polyline `points` 글자. 기존 서비스 LineGraph 와 같은 셈:
 * 가로 = 날짜(시간 비례), 세로 = 금액(최소 ~ 최대). 안쪽 여백 위 4 · 오른쪽 10 · 아래 10 · 왼쪽 4.
 * 값이 모두 같으면(폭 0) 가로는 왼쪽, 세로는 아래에 붙는다(기존과 같다). 금액 · 날짜가 없는 점은 뺀다.
 */
export function sparklinePath(points: SparklinePoint[], width: number, height: number): string {
  const valid = points
    .map((point) => ({ x: toDay(point.date), y: point.amount }))
    .filter(
      (point): point is { x: number; y: number } => point.x !== null && Number.isFinite(point.y),
    );
  if (valid.length === 0) return '';
  const xs = valid.map((point) => point.x);
  const ys = valid.map((point) => point.y);
  const xMin = Math.min(...xs);
  const yMin = Math.min(...ys);
  const xGap = Math.max(...xs) - xMin || 1;
  const yGap = Math.max(...ys) - yMin || 1;
  const { top, right, bottom, left } = SPARKLINE_MARGIN;
  const innerWidth = width - left - right;
  const innerHeight = height - top - bottom;
  return valid
    .map((point) => {
      const x = left + ((point.x - xMin) / xGap) * innerWidth;
      const y = height - bottom - ((point.y - yMin) / yGap) * innerHeight;
      return `${round(x)},${round(y)}`;
    })
    .join(' ');
}
